import { RcFile } from "antd/lib/upload";
import axiosInstance from "../../axios/axios";
import { SubmitCoverWizardDto } from "./dtos/SubmitCoverWizardDto";
import { requestHeader } from "./sharedUtils";
import QueryResponse from "./shared models/QueryResponse";
import { AxiosResponse } from "axios";
import { SubmitHardwareOrderDto } from "../../pages/Order/CreateHardwareOrderModal/CreateHardwareOrderModal";

export const uploadAttachments = async (
  files: RcFile[],
  soNumber: string,
  comments: string,
  formPayload?: SubmitCoverWizardDto
) => {
  try {
    const payload = new FormData();
    payload.append("sono", soNumber);
    payload.append("comments", comments);
    payload.append("orderValues", JSON.stringify(formPayload));
    files.forEach((file) => {
      payload.append("files", file, file.name); // 'files' is the key
    });
    const response = await axiosInstance.post(
      "/UploadAttachments",
      payload,
      requestHeader
    );
    return [response, null];
  } catch (err) {
    return [null, err];
  }
};

export const submitCoverWizardData = async (
  requestDto: SubmitCoverWizardDto
): Promise<[AxiosResponse<number> | null, unknown]> => {
  try {
    const response = await axiosInstance.post<number>(
      "/OrderForm",
      requestDto,
      requestHeader
    );
    return [response, null];
  } catch (err) {
    return [null, err];
  }
};

export const getOrderDetails = async (
  soNo: string
): Promise<[QueryResponse<SubmitCoverWizardDto> | null, unknown]> => {
  try {
    const response = await axiosInstance.get<
      QueryResponse<SubmitCoverWizardDto>
    >(`/OrderDetails/${soNo}`, requestHeader);
    return [response.data, null];
  } catch (err) {
    return [null, err];
  }
};

export const uploadMeasurements = async (
  files: RcFile[],
  soNumber: number,
  jobName: string,
  orderType: string,
  comments: string
) => {
  try {
    const payload = new FormData();
    payload.append("sono", soNumber.toString());
    payload.append("jobName", jobName);
    payload.append("orderType", orderType);
    payload.append("distanceFromAToB", comments);
    files.forEach((file) => {
      payload.append("files", file, file.name); // 'files' is the key
    });
    const response = await axiosInstance.post(
      "/UploadMeasurements",
      payload,
      requestHeader
    );
    return [response, null];
  } catch (err) {
    return [null, err];
  }
};
